import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs/Observable";
import { Lot } from "../models/lot.model";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Employee } from "../models/employee.model";

@Injectable()
export class LotService {
  constructor(private api: ApiService) {}

  getAll(params): Observable<any[]> {
    return this.api.get('lots?' + params);
  }

  find(id: number): Observable<Lot> {
    return this.api.get("lots/" + id);
  }

  stats(id: number, params): Observable<any[]> {
    return this.api.get("lots/" + id + "/stats?" + params);
  }

  getEmployees(id: number): Observable<Employee[]> {
    return this.api.get("lots/" + id + "/employees");
  }

  getDataForExcel(lotId: number, params: any): Observable<Employee[]> {
    return this.api.get("lots/" + lotId + "/download-excel?" + params);
  }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/lot.service.ts